import React from 'react';
import styles from '../../OrderStatus.module.css';
import { useAjax } from '@developers/use-ajax';
import * as ordersAjax from '../../../../ajax/orders';

const DetailsBlock = (props) => {

  const [returnAuthorizationProducts, getReturnAuthorizationProducts, getReturnAuthorizationProductsMeta] = useAjax(ordersAjax.getReturnAuthorizationProducts, []);

  React.useEffect(() => {
    getReturnAuthorizationProducts(props.ra.ra_id, props.validators.token);
  }, []);

  function getStatus(ra) {
    if (!ra.ra_date_received) {
      return 'NOT RECEIVED';
    }

    if (ra.ra_credit_memo_id) {
      return 'REFUNDED';
    }

    if (ra.purchase_id_replace) {
      return 'REPLACED';
    }

    if (ra.ra_credit_close_date) {
      return 'REJECTED';
    }

    return 'CLOSED';
  }

  function getStatusInfo(ra, status) {
    if (status == 'REFUNDED') {
      if (ra.ra_credit_memo_id) {
        return ' Credit Memo: ' + ra.ra_credit_memo_id;
      }
    }

    if (status == 'REPLACED') {
      return ' Order: ' + ra.purchase_id_replace;
    }

    return '';
  }

  return (
    <table key={props.ra.ra_id}>
      <tbody>
        <tr>
          <td className={styles.detailTitle}>
            <strong>RA#:</strong>
          </td>
          <td className={styles.detail}>
            <strong>{'RA' + props.ra.ra_id}</strong>
          </td>
        </tr>
        <tr>
          <td className={styles.detailTitle}>
            <strong>Date Issued:</strong>
          </td>
          <td className={styles.detail}>
            {new Date(props.ra.ra_date_issued).toLocaleDateString('en-US')}
          </td>
        </tr>
        <tr>
          <td className={styles.detailTitle}>
            <strong>Expires:</strong>
          </td>
          <td className={styles.detail}>
            {new Date(props.ra.expirationDate).toLocaleDateString('en-US')}
          </td>
        </tr>
        <tr>
          <td className={styles.detailTitle}>
            <strong>Closed:</strong>
          </td>
          <td className={styles.detail}>
            {props.ra.ra_credit_close_date && new Date(props.ra.ra_credit_close_date).toLocaleDateString('en-US')}
          </td>
        </tr>
        <tr>
          <td className={styles.detailTitle}>
            <strong>Status:</strong>
          </td>
          <td className={styles.detail}>
            {getStatus(props.ra) + ' ' + getStatusInfo(props.ra, getStatus(props.ra))}
          </td>
        </tr>
        <tr>
          <td className={styles.detailTitle}>
            <strong>Date Received:</strong>
          </td>
          <td className={styles.detail}>
            {props.ra.ra_date_received && new Date(props.ra.ra_date_received).toLocaleDateString('en-US')}
          </td>
        </tr>
        <tr>
          <td className={styles.detailTitle}>
            <strong>Parts on RA:</strong>
          </td>
          {returnAuthorizationProducts?.map((product) => {
            return (
              <td key={product.product_id} className={styles.detail}>
                {'Qty ' + product.ra_data.ra_item_qty + ' of '}<a href={product.link}>{product.product_id}</a>{' (' + product.product_name + ')'}
              </td>
            );
          })}
        </tr>
        <tr>
          <td className={styles.detailTitle}>
            <strong>Reason for Return:</strong>
          </td>
          <td className={styles.detail}>
            {props.ra.ra_reason}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default DetailsBlock;